import moment from 'moment'
import Decimal from 'decimal.js'

// todo 时间处理
export const UniteYMDHms = (time: string) => { // 2019-09-05 13:14:52
  if (!time) {
    return ''
  }
  let t = Number(time)
  return moment(t * 1000).format('YYYY-MM-DD HH:mm:ss')
}
export const UniteHmsYMD = (time: string) => { //13:14:52 2019-09-05
  if (!time) {
    return ''
  }
  return moment(time).format('HH:mm:ss YYYY-MM-DD')
}
export const UniteYMD = (time: string) => { // 2019-09-05
  if (!time) {
    return ''
  }
  return moment(time).format('HH:mm:ss YYYY-MM-DD')
}
// 数处理
export const UniteTowPlaces = (num: number | string) => { // 保留两位小数 （12.3> 12.30）
  return new Decimal(num).toFixed(2)
}
export const UnitePercentage = (num: number | string) => { // (小数)转百分比(保留两位小数) （0.1 => 10.00%）
  return new Decimal(num).mul(100).toFixed(2) + '%'
}
// sv pv 转换
export const GetSvFiter = (num: number) => { // sv
  let oSv = {
    1: '登录,支出,收入,风险,其他',
    2: '登录',
    4: '支出',
    8: '收入',
    16: '风险',
    32: '其他'
  }
  let str = ''
  Object.keys(oSv).forEach(item => {
    // @ts-ignore
    if (num & item) {
      // @ts-ignore
      str = str + oSv[item] + ','
    }
  })

  return str.substr(0, str.length - 1)
}
export const GetPvFiter = (num: number) => { // pv
  let oPv = {
    1: '支付宝,银行,银联,微信,网络服务商,其他',
    2: '支付宝',
    4: '银行',
    8: '银联',
    16: '微信',
    32: '网络服务商',
    64: '其他'
  }
  let str = ''
  Object.keys(oPv).forEach(item => {
    // @ts-ignore
    if (num & item) {
      // @ts-ignore
      str = str + oPv[item] + ','
    }
  })
  return str.substr(0, str.length - 1)
}
export const GetSub = (arr: any) => { // pv
  let str = ''
  if (!arr) {
    return ''
  }
  //@ts-ignore
  arr.forEach(item => {
    str = str + item.name + ','
  })
  return str.substr(0, str.length - 1)
}
export const GetBindSub = (arr: any) => { // pv
  console.log(arr)
  if (!arr) {
    return ''
  }
  return arr.join(',')
}